import { Box, ColorOptions, Loader, ModBox, Spacer, Text, useWindowDimensions } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { useEffect, useState } from 'react'
import { Dropdown } from '../../components/Dropdown'
import { List } from '../../components/List'
import PaginationController from '../../components/PaginationController/PaginationController'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import {
  getPosCustomColumnWidth,
  pageSizeList,
  posApprovalHeadTitles,
  posApprovedHeadTitles,
  posStatusList,
} from '../../utils/constants'

const PosApprovals = () => {
  const {
    getApprovals,
    updateApprovalsOnCheck,
    updateApprovalsAllCheck,
    approveOrDecline,
    fetchPendingApprovals,
    getIsAllChecked,
    getCheckedIds,
    paginationData,
    updatePagination,
    pagenumber,
    updatePageSize,
    pageSize,
    accessConfig,
  } = useStores((store) => ({
    getApprovals: store.posApprovals.getApprovals,
    updateApprovalsOnCheck: store.posApprovals.updateApprovalsOnCheck,
    updateApprovalsAllCheck: store.posApprovals.updateApprovalsAllCheck,
    getCheckedIds: store.posApprovals.getCheckedIds,
    approveOrDecline: store?.posApprovals?.approveOrDecline,
    fetchPendingApprovals: store?.posApprovals?.fetchPendingApprovals,
    length: store.posApprovals.pos.length,
    getIsAllChecked: store.posApprovals.getIsAllChecked,
    paginationData: store?.posApprovals?.pagination,
    pagenumber: store?.posApprovals?.pagination?.number,
    pageSize: store?.posApprovals?.pagination?.size,
    updatePagination: store?.posApprovals?.updatePagination,
    updatePageSize: store?.posApprovals?.updatePageSize,
    accessConfig: store.user.getAccessConfig(['pos', 'epfa']),
  }))

  const listData = getApprovals()
  const [lazyDeclineApi, { state: declineApiState }] = useLazyApiData(approveOrDecline)
  const [lazyApproveApi, { state: approveApiState }] = useLazyApiData(approveOrDecline)
  const [lazyFetchApi, { state: fetchApiState }] = useLazyApiData(fetchPendingApprovals)

  const [status, setStatus] = useState('RESPONSE_RECIEVED')
  const [sortOrder, setSortOrder] = useState([])
  useEffect(() => {
    lazyFetchApi(status, sortOrder)
  }, [pagenumber, pageSize, sortOrder])

  useEffect(() => {
    if (approveApiState === 'fulfilled' || declineApiState === 'fulfilled') {
      lazyFetchApi(status, sortOrder)
    }
  }, [declineApiState, approveApiState, sortOrder])

  console.log(listData.length)
  const handleApprove = (type) => {
    if (getCheckedIds()?.length > 0) {
      lazyApproveApi(type)
    }
  }

  const handleDecline = (type) => {
    if (getCheckedIds()?.length > 0) {
      lazyDeclineApi(type)
    }
  }

  const onPageSizeSelect = (pageSize: number) => {
    updatePagination(0)
    updatePageSize(pageSize)
  }

  const onStatusChange = (status: any) => {
    setStatus(status)
    lazyFetchApi(status, sortOrder)
  }

  const onSortPress = (key: any) => {
    const keyValueMap = {
      id: 'id',
      processingEntity: 'processingEntity',
      bankName: 'bankName',
      entityId: 'emsEntityId',
      createdAt: 'createdAt',
    }
    if (keyValueMap[key]) {
      const keyValue = keyValueMap[key]
      const keyExists = sortOrder?.find((item) => item?.[0] === keyValue)
      if (keyExists) {
        const updatedOrder = sortOrder?.map((item) => {
          if (item?.[0] === key) {
            return [keyValue, item?.[1] === 'asc' ? 'desc' : 'asc']
          } else {
            return item
          }
        })
        setSortOrder(updatedOrder)
      } else {
        setSortOrder([...sortOrder, [keyValue, 'asc']])
      }
    }
  }
  const width = useWindowDimensions()
  const headerTitles = status === 'RESPONSE_RECIEVED' ? posApprovalHeadTitles : posApprovedHeadTitles
  return (
    <Box>
      <Box flexDirection={'row'} justify={'space-between'}>
        <Text title={'POS Pending Approvals'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
        <ModBox flexDirection={'row'} show={fetchApiState !== 'pending'}>
          <Box flexDirection={'row'} align={'center'}>
            <Dropdown data={posStatusList} selectedData={onStatusChange} value={status} minWidth={200} />
            <Spacer direction="horizontal" size={16} />
            <Text title={'Rows per page: '} fontFamily={'jiotype-medium'} fontSize={14} color={'PRIMARY_GREY'} />
            <Dropdown data={pageSizeList} selectedData={onPageSizeSelect} value={'' + pageSize} />
          </Box>
          <Spacer direction="horizontal" size={8} />
          <PaginationController
            currentPage={paginationData?.number ?? 0}
            totalPages={paginationData?.totalPages ?? 0}
            totalDataLength={paginationData?.totalElements ?? 0}
            dataSetSize={paginationData?.size ?? 0}
            onSelect={updatePagination}
            isZeroIndex={true}
            defaultPage={0}
          />
        </ModBox>
      </Box>
      <Spacer direction="vertical" size={24} />
      {fetchApiState === 'pending' && <Loader />}
      {fetchApiState !== 'pending' && (
        <Box w={width - 270} overflowX="auto">
          <List
            keyExtractor={(item: any) => item.id}
            type={'SCROLLABLE'}
            headTitle={headerTitles}
            data={listData?.slice()}
            listTitle={''}
            isColumnSearchEnabled={false}
            onAllChecked={(isAllChecked) => updateApprovalsAllCheck(isAllChecked)}
            isAllChecked={getIsAllChecked()}
            onChecked={(val, index) => updateApprovalsOnCheck(listData?.[index]?.id, val)}
            hidePagination={true}
            pageSizeFromApi={pageSize}
            updateSortKeys={onSortPress}
            sortOrder={sortOrder}
            columnsWidth={getPosCustomColumnWidth}
            tableWidth={status === 'RESPONSE_RECIEVED' ? 1920 : 1840}
          />
        </Box>
      )}

      <Spacer direction="vertical" size={24} />
      <ModBox
        flexDirection={'row'}
        align={'center'}
        justify={'center'}
        show={
          isAccessible(accessConfig, 'approve') &&
          status === 'RESPONSE_RECIEVED' &&
          listData?.length > 0 &&
          fetchApiState === 'fulfilled'
        }>
        <ButtonNew
          title={'Approve'}
          onPress={() => handleApprove('APPROVE')}
          color={'GREEN'}
          disabled={getCheckedIds()?.length === 0}
          isLoading={approveApiState === 'pending'}
        />
        <Spacer direction="horizontal" size={14} />
        <ButtonNew
          title={'Decline'}
          onPress={() => handleDecline('REJECT')}
          color={'RED'}
          disabled={getCheckedIds()?.length === 0}
          isLoading={declineApiState === 'pending'}
        />
      </ModBox>
    </Box>
  )
}

export default PosApprovals
